<ng-container *ngIf="app !== 'waterfall'">
  <mat-slide-toggle test-id="hide-email" [formControl]="form">Hide my email</mat-slide-toggle>
  <p *ngIf="app !== 'financiers'" class="mat-caption">Your email address will be visible to all Archipel users unless you decide to hide it.</p>
  <p *ngIf="app === 'financiers'" class="mat-caption">Your email address will be visible to all Media Financiers users unless you decide to hide it.</p>
  <p *ngIf="app !== 'financiers'" class="mat-caption">
    NB: Please note that in the event that you interact with a sales agent or their film(s), your email will be made visible to them regardless. 
    For more information, please refer to our <a href="/auth/privacy" target="_blank">Privacy Policy</a>.
  </p>
</ng-container>